import { Link } from 'react-router-dom';

import React, { useState, useEffect } from 'react';
import styles from './Students.module.css';
import { stages } from '../../../data/studentsData';
import apiClient from '../../../api/client';

const Students = () => {
  const [selectedStage, setSelectedStage] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  // 1. مخزن الطلاب الحقيقي اللي جاي من الداتا بيز
  const [students, setStudents] = useState([]);

  // مخزن المجموعات (بقت بتتجاب من الباك إند بدل ما تكون مكتوبة في الكود)
  const [groups, setGroups] = useState([]);

  // 2. مخزن لبيانات الفورم عشان نبعتها للسيرفر
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    grade: '',
    group: '',
    parentPhone: ''
  });

  // --- دالة جلب الطلاب من الباك إند (GET) ---
  const fetchStudents = async () => {
    try {
      const { data } = await apiClient.get('/students');
      setStudents(data); // بنحط الداتا في المخزن
    } catch (error) {
      console.error("❌ مشكلة في جلب بيانات الطلاب:", error);
    }
  };

  // تشغيل دالة الجلب أول ما الصفحة تفتح
  useEffect(() => {
    fetchStudents();
    apiClient.get('/groups')
      .then(res => setGroups(res.data))
      .catch(err => console.error("❌ مشكلة في جلب المجموعات:", err));
  }, []);

  // --- دالة حذف طالب من القايمة ---
  const handleDeleteStudent = async (student) => {
    if (!window.confirm(`متأكد إنك عايز تحذف الطالب "${student.name}"؟ الحذف مش هينفع يترجع تاني.`)) return;
    try {
      await apiClient.delete(`/students/${student._id}`);
      setStudents(prev => prev.filter(s => s._id !== student._id));
    } catch (error) {
      console.error("❌ مشكلة في حذف الطالب:", error);
      const message = error.response?.data?.message || 'مشكلة في حذف الطالب!';
      alert(`حصلت مشكلة: ${message}`);
    }
  };

  // --- دالة حفظ طالب جديد في الباك إند (POST) ---
  const handleAddStudent = async (e) => {
    e.preventDefault(); // عشان الصفحة ما تعملش ريفريش
    try {
      const { data: savedStudent } = await apiClient.post('/students', formData);
      // بنضيف الطالب الجديد للجدول فوراً من غير ريفريش
      setStudents([...students, savedStudent]);
      setIsModalOpen(false); // بنقفل النافذة
      // بنفضي الفورم تاني
      setFormData({ name: '', code: '', grade: '', group: '', parentPhone: '' });
      alert('تم حفظ الطالب في قاعدة البيانات بنجاح! 🎉');
    } catch (error) {
      console.error("❌ مشكلة في حفظ الطالب:", error);
      const message = error.response?.data?.message || 'مشكلة في الاتصال بالسيرفر!';
      alert(`حصلت مشكلة: ${message}`);
    }
  };

  const filteredGroups = selectedStage
    ? groups.filter(g => g.stage === selectedStage)
    : groups;

  // تحديث الفلترة عشان تشتغل مع مسميات الداتا بيز (grade بدل stage)
  const filteredStudents = students.filter(student => {
    const matchStage = selectedStage ? student.grade === selectedStage : true;
    const matchGroup = selectedGroup ? student.group === selectedGroup : true;
    return matchStage && matchGroup;
  });

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.header}>
        <h1 className={styles.title}>إدارة الطلاب</h1>
        <button className={styles.addBtn} onClick={() => setIsModalOpen(true)}>
          + إضافة طالب جديد
        </button>
      </div>

      <div className={styles.filtersContainer}>
        <select
          className={styles.selectBox}
          value={selectedStage}
          onChange={(e) => {
            setSelectedStage(e.target.value);
            setSelectedGroup('');
          }}
        >
          <option value="">كل المراحل الدراسية</option>
          {stages.map((stage, index) => (
            <option key={index} value={stage}>{stage}</option>
          ))}
        </select>

        <select
          className={styles.selectBox}
          value={selectedGroup}
          onChange={(e) => setSelectedGroup(e.target.value)}
          disabled={!selectedStage}
        >
          <option value="">كل المجموعات والمواعيد</option>
          {filteredGroups.map(group => (
            // خلينا الـ value هي اسم المجموعة عشان تتخزن كنص في الداتا بيز
            <option key={group._id} value={group.name}>
              {group.name} - {group.time}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.table}>

          <thead>
            <tr>
              <th>كود الطالب</th>
              <th>الاسم</th>
              <th>المرحلة</th>
              <th>رقم ولي الأمر</th>
              <th>الحالة</th>
              <th>حذف</th>
            </tr>
          </thead>
          <tbody>
            {filteredStudents.length > 0 ? (
              filteredStudents.map(student => (
                <tr key={student._id}> {/* الداتا بيز بتعمل الـ id بالشكل ده _id */}
                  <td>{student.code}</td>
                  <td><Link to={`/student-report/${student._id}`}>{student.name}</Link></td>
                  <td>{student.grade}</td>
                  <td>{student.parentPhone}</td>
                  <td><span className={styles.statusActive}>{student.status || 'نشط'}</span></td>
                  <td>
                    <button
                      type="button"
                      className={styles.deleteBtn}
                      onClick={() => handleDeleteStudent(student)}
                      title="حذف الطالب"
                    >
                      🗑️ حذف
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', color: '#6b7280' }}>
                  لا يوجد طلاب في هذه المجموعة حالياً
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h2 className={styles.title} style={{ fontSize: '1.25rem' }}>إضافة طالب جديد</h2>
              <button className={styles.closeBtn} onClick={() => setIsModalOpen(false)}>×</button>
            </div>

            {/* ربطنا الفورم بدالة الحفظ */}
            <form onSubmit={handleAddStudent}>

              <div className={styles.formGroup}>
                <label>كود الطالب</label>
                <input
                  type="text"
                  className={styles.formInput}
                  placeholder="مثال: 1001"
                  required
                  value={formData.code}
                  onChange={(e) => setFormData({...formData, code: e.target.value})}
                />
              </div>

              <div className={styles.formGroup}>
                <label>اسم الطالب رباعي</label>
                <input
                  type="text"
                  className={styles.formInput}
                  placeholder="مثال: أحمد محمود علي"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                />
              </div>

              <div className={styles.formGroup}>
                <label>المرحلة الدراسية</label>
                <select
                  className={styles.formInput}
                  required
                  value={formData.grade}
                  onChange={(e) => setFormData({...formData, grade: e.target.value})}
                >
                  <option value="">اختر المرحلة</option>
                  {stages.map((stage, index) => <option key={index} value={stage}>{stage}</option>)}
                </select>
              </div>

              <div className={styles.formGroup}>
                <label>المجموعة</label>
                <select
                  className={styles.formInput}
                  required
                  value={formData.group}
                  onChange={(e) => setFormData({...formData, group: e.target.value})}
                >
                  <option value="">اختر المجموعة</option>
                  {/* بنجيب المجموعات المتاحة للمرحلة اللي اختارها في الفورم */}
                  {groups.filter(g => g.stage === formData.grade).map(group => (
                    <option key={group._id} value={group.name}>{group.name} - {group.time}</option>
                  ))}
                </select>
              </div>

              <div className={styles.formGroup}>
                <label>رقم هاتف ولي الأمر</label>
                <input
                  type="tel"
                  className={styles.formInput}
                  placeholder="01xxxxxxxxx"
                  required
                  value={formData.parentPhone}
                  onChange={(e) => setFormData({...formData, parentPhone: e.target.value})}
                />
              </div>

              <button type="submit" className={styles.submitBtn}>حفظ بيانات الطالب</button>
            </form>
          </div>
        </div>
      )}

    </div>
  );
};

export default Students;
